import { combineReducers } from 'redux'
import { Reducer } from 'interfaces'
import { ViewportState, ViewportMatchName, MediaMatches } from 'interfaces/viewport'
import { SET_MEDIA_MATCH, APPEND_MEDIA_MATCHES, SET_VIEWPORT_MATCH, SET_FULLSCREEN_MODE } from 'actions/viewportActions'

const viewport: Reducer<ViewportMatchName | null> = (state = null, action) => {
  if (action.type === SET_VIEWPORT_MATCH) {
    return action.payload
  }

  return state
}

const mediaMatches: Reducer<MediaMatches> = (state: MediaMatches = {}, action) => {
  switch (action.type) {
    case SET_MEDIA_MATCH: {
      const { name, value } = action.payload

      return {
        ...state,
        [name]: value,
      }
    }

    case APPEND_MEDIA_MATCHES: {
      return {
        ...state,
        ...action.payload,
      }
    }

    default:
      return state
  }
}

const isFullscreenEnabled: Reducer<boolean> = (state = false, action) => {
  if (action.type === SET_FULLSCREEN_MODE) {
    return action.payload
  }

  return state
}

export default combineReducers<ViewportState>({
  isFullscreenEnabled,
  viewport,
  mediaMatches,
})
